<style lang="sass">
  body.pinhigh-modal-open
    height: 100vh
    width: 100vw
    overflow: hidden
</style>
<style scoped lang="sass">
.pinhigh-modal-wrapper
  z-index: 3
  position: fixed
  display: flex
  justify-content: center
  align-items: center
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0,0,0,0.5)
  .pinhigh-modal
    width: 80%
    max-height: 80%
    background-color: white
    border-radius: 0.5rem
    padding: var(--base-padding)
    .pinhigh-modal-inner
      overflow: auto
    >button
      margin-top: 1rem
</style>
<template>
  <transition appear name="fade-quickly">
    <div class="pinhigh-modal-wrapper" @click.self.prevent="backdropClicked">
      <div class="pinhigh-modal">
        <div class="pinhigh-modal-inner">
          <slot></slot>
        </div>
        <button @click.prevent="close" class="button boring" v-if="closeButton">Close</button>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'PinhighModal',
  props: {
    onClose: {
      type: Function
    },
    closeButton: {
      type: Boolean,
      defaultValue: true
    },
    disableBackdropClose: {
      type: Boolean,
      defaultValue: false
    }
  },
  mounted() {
    document.querySelector('body').classList.add('pinhigh-modal-open');
  },
  destroyed() {
    document.querySelector('body').classList.remove('pinhigh-modal-open');
  },
  methods: {
    backdropClicked() {
      this.disableBackdropClose ? null : this.close();
    },
    close() {
      this.onClose ? this.onClose() : this.$emit('close');
    }
  }
};
</script>
